// components/HomePage/components/Coach/types/CoachCallStrength.jsx
import React, { useCallback, useEffect } from "react";
import { toast } from "react-hot-toast";
import panda from "../../../../assets/panda-partner.png";

const CoachCallStrength = ({ subsection, saveProgress, actions }) => {
  const handleJoinCall = useCallback(async () => {
    await saveProgress("completed", { joined: true });
    toast.success("You’ve joined the coaching session!");
  }, [saveProgress]);

  useEffect(() => {
    actions?.setPrimary({ visible: false });
    return () => actions?.clearPrimary?.();
  }, [actions]);

  return (
    <div className="flex flex-col items-center text-center space-y-6">
<img
  src={panda}
  alt="Coach Partner"
  className="w-[345px] h-[360px] object-contain mx-auto"
/>
      <p className="text-gray-600 max-w-md text-lg leading-relaxed">
        Your coach will connect with you shortly to discuss your goals and progress.
      </p>
      <button
        onClick={handleJoinCall}
        className="mt-4 bg-[#54B0AF] hover:bg-teal-600 text-white font-semibold px-6 py-3 rounded-lg shadow-md transition-all"
      >
        Join Coaching Session
      </button>
    </div>
  );
};

export default CoachCallStrength;
